var _path, _path2, _path3, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenshotMetric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9156_13287)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9156_13287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9156_13287)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9156_13287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9156_13287)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9156_13287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9156_13287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.3726 18.6274 0 12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24Z",
    fill: "url(#paint0_linear_9156_13287)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9156_13287)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0248 11.9103H16.4494L17.2296 13.293H18.8372C18.9228 13.293 18.9926 13.3649 18.9926 13.4477V18.8442C18.9926 18.9271 18.9212 18.9989 18.8372 18.9989H9.50204C9.41884 18.9981 9.34667 18.9286 9.34667 18.8442V13.4477C9.34667 13.3626 9.41651 13.293 9.50204 13.293H12.0884C12.2901 12.8961 12.4919 12.5001 12.6936 12.1032C12.816 11.8619 12.7485 11.9103 13.0248 11.9103ZM7.72325 19H5V15.8857H6.26417V17.7418H7.72325V19ZM5 14.1801V9.81992H6.26417V14.1801H5ZM5 8.11437V5H8.09581V6.25817H6.26417V8.11437H5ZM9.80949 5H14.1905V6.25817H9.80949V5ZM15.9042 5H19V10.6418H17.7358V6.25817H15.9042V5ZM17.9863 13.9765C18.2422 13.9765 18.4494 14.1828 18.4494 14.4375C18.4494 14.6921 18.2422 14.8983 17.9863 14.8983C17.7304 14.8983 17.5232 14.6921 17.5232 14.4375C17.524 14.1828 17.7312 13.9765 17.9863 13.9765ZM14.5774 14.5133C15.3521 14.5133 15.9808 15.139 15.9808 15.9101C15.9808 16.6811 15.3521 17.3069 14.5774 17.3069C13.8027 17.3069 13.1739 16.6811 13.1739 15.9101C13.1739 15.139 13.8027 14.5133 14.5774 14.5133ZM14.5774 13.604C15.8576 13.604 16.8953 14.6367 16.8953 15.9108C16.8953 17.1842 15.8576 18.2177 14.5774 18.2177C13.298 18.2177 12.2595 17.1842 12.2595 15.9108C12.2603 14.6367 13.298 13.604 14.5774 13.604Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9156_13287",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9156_13287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9156_13287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshotMetric);
export default __webpack_public_path__ + "static/media/screenshot-metric.7090e92f3721762c8db2e9a4432a3040.svg";
export { ForwardRef as ReactComponent };